/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const ShoppingCart: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M6.49993 23.9998C7.88063 23.9998 8.99991 22.8805 8.99991 21.4998C8.99991 20.1191 7.88063 18.9998 6.49993 18.9998C5.11924 18.9998 3.99996 20.1191 3.99996 21.4998C3.99996 22.8805 5.11924 23.9998 6.49993 23.9998Z'
      fill='currentColor'
    />
    <path
      d='M19.4998 23.9998C20.8805 23.9998 21.9998 22.8805 21.9998 21.4998C21.9998 20.1191 20.8805 18.9998 19.4998 18.9998C18.1191 18.9998 16.9998 20.1191 16.9998 21.4998C16.9998 22.8805 18.1191 23.9998 19.4998 23.9998Z'
      fill='currentColor'
    />
    <path
      d='M19.9998 16.9998H5.99994C5.49894 16.9998 5.07495 16.6288 5.00895 16.1318L3.12497 1.99998H0V0H3.99996C4.50095 0 4.92495 0.370996 4.99095 0.867991L5.54194 4.99995H22.9998C23.3158 4.99995 23.6138 5.14895 23.8018 5.40294C23.9908 5.65694 24.0488 5.98494 23.9578 6.28694L20.9578 16.2868C20.8308 16.7098 20.4408 16.9998 19.9998 16.9998Z'
      fill='currentColor'
    />
  </React.Fragment>
)
